module.exports = __webpack_public_path__ + "static/product-l0950-olive-drab-d5520b036356eb774ee7df4075ca186e.png";